import React, { useEffect, useRef, useCallback, useState, useMemo } from 'react';
import { BrowserRouter, Routes, Route, Link, useLocation } from 'react-router-dom';
import AntUserLogin from '../AntUserLogin';
import AntBusinessRegister from '../AntBusinessRegister';
import AntBusinessRecovery from '../AntBusinessRecovery';
import cs from '../../utils/const.js';
import AntString from '../../utils/AntString';
import AntLocalization from '../../utils/AntLocalization';

import { AntGlobal, AntSessionContext } from '../../utils/AntContext';
import stringify from '../../utils/stableStringify';
import IndustryFeatures from '../AntBusinessRegister/IndustryFeatures';

function AuthRouteObserver(props) {
    const location = useLocation();

    useEffect(() => {
        props.onPathChanged(location.pathname);
    }, [location.pathname, props.onPathChanged]);

    return null;
}

export default function (props) {
    const appGlobal = AntGlobal();

    const marginLeft = appGlobal.appInfo && appGlobal.appInfo.login && appGlobal.appInfo.login.alignLeft ? '100px' : undefined;
    const marginRight = appGlobal.appInfo && appGlobal.appInfo.login && appGlobal.appInfo.login.alignRight ? '100px' : undefined;

    const [registerSubIndustry, setRegisterSubIndustry] = useState(null);
    const [authPath, setAuthPath] = useState(() => window.location.pathname);

    const [sysLanguages, setSysLanguages] = useState(() => {
        try {
            var cached = localStorage.getItem(cs.System_Code + '-Sys_Languages');
            if (cached) return JSON.parse(cached);
        } catch (e) {}
        return ['vi-VN', 'en-US', 'es-ES', 'zh-CN', 'fr-FR'];
    });
    const [currentLang, setCurrentLang] = useState(() => {
        var lang = localStorage.getItem(cs.System_Code + '-Sys_BaseLanguage');
        if (lang) {
            var short = lang.split('-')[0];
            if (short) return short;
        }
        return 'vi';
    });

    var flags = useMemo(() => {
        var obj = {};
        for (var i = 0; i < sysLanguages.length; i++) {
            var lang = sysLanguages[i];
            if (lang.startsWith('vi')) obj['vi'] = 'https://flagcdn.com/w40/vn.png';
            else if (lang.startsWith('en')) obj['en'] = 'https://flagcdn.com/w40/us.png';
            else if (lang.startsWith('fr')) obj['fr'] = 'https://flagcdn.com/w40/fr.png';
            else if (lang.startsWith('ja')) obj['ja'] = 'https://flagcdn.com/w40/jp.png';
            else if (lang.startsWith('zh')) obj['zh'] = 'https://flagcdn.com/w40/cn.png';
            else if (lang.startsWith('ko')) obj['ko'] = 'https://flagcdn.com/w40/kr.png';
            else if (lang.startsWith('es')) obj['es'] = 'https://flagcdn.com/w40/es.png';
            else if (lang.startsWith('id')) obj['id'] = 'https://flagcdn.com/w40/id.png';
            else if (lang.startsWith('hi')) obj['hi'] = 'https://flagcdn.com/w40/in.png';
            else if (lang.startsWith('ar')) obj['ar'] = 'https://flagcdn.com/w40/sa.png';
        }
        return obj;
    }, [sysLanguages]);

    var onChangeLanguage = useCallback((value) => {
        var map = {
            vi: 'vi-VN',
            en: 'en-US',
            fr: 'fr-FR',
            ja: 'ja-JP',
            zh: 'zh-CN',
            ko: 'ko-KR',
            es: 'es-ES',
            id: 'id-ID',
            hi: 'hi-IN',
            ar: 'ar-SA'
        };
        localStorage.setItem(cs.System_Code + '-Sys_BaseLanguage', String(map[value] || 'vi-VN'));
        // Đánh dấu user tự chọn → initBaseURL không ghi đè bằng defaultLanguage theo IP nữa
        localStorage.setItem(cs.System_Code + '-Sys_BaseLanguage_Manual', '1');
        setCurrentLang(value);
        window.location.reload();
    }, []);

    const initBaseURL = useCallback(() => {
        var initURL = '/user/ACUserAuthen/getExternalSessionInfo';

        var BaseURL = localStorage.getItem(cs.System_Code + '-Sys_BaseURL');
        if (!BaseURL || BaseURL === 'null' || BaseURL === 'undefined') BaseURL = cs.BaseURL;

        var queryURL = AntString.clean(BaseURL + initURL);

        const header = {
            'Content-Type': 'application/json',
            Accept: 'application/json'
        };

        fetch(queryURL, {
            method: 'POST',
            headers: header
        })
            .then((response) => response.json())
            .then((data) => {
                if (data?.data?.apiBaseURL) {
                    let hostURL = data?.data?.apiBaseURL;
                    if (!/^https?:\/\//i.test(hostURL)) {
                        hostURL = 'https://' + hostURL;
                    }

                    localStorage.setItem(cs.System_Code + '-Sys_BaseURL', String(hostURL));
                }
                if (data?.data?.defaultLanguage) {
                    // Ngôn ngữ user tự chọn (bấm cờ) ưu tiên cao nhất — không để defaultLanguage theo IP đè lên
                    var manual = localStorage.getItem(cs.System_Code + '-Sys_BaseLanguage_Manual');
                    var chosen = localStorage.getItem(cs.System_Code + '-Sys_BaseLanguage');
                    var hasChosen = manual === '1' && chosen && chosen !== 'null' && chosen !== 'undefined';

                    if (!hasChosen) {
                        let language = data?.data?.defaultLanguage;
                        localStorage.setItem(cs.System_Code + '-Sys_BaseLanguage', String(language));
                    }
                }
                if (data?.data?.defaultCurrency) {
                    let currency = data?.data?.defaultCurrency;
                    localStorage.setItem(cs.System_Code + '-Sys_DefaultCurrency', String(currency));
                }
                if (data?.data?.registerWithPhoneNumber !== undefined) {
                    let value = data?.data?.registerWithPhoneNumber;
                    localStorage.setItem(cs.System_Code + '-Sys_RegisterWithPhoneNumber', String(value));
                }
                if (data?.data?.languages) {
                    let languages = data?.data?.languages;
                    localStorage.setItem(cs.System_Code + '-Sys_Languages', stringify(languages));
                    setSysLanguages(languages);
                }
            })
            .catch((er) => {});
    }, []);

    useEffect(() => {
        initBaseURL();
    }, []);

    var { appInfo, appAssets } = appGlobal;
    var logoWithBrand = appAssets && appAssets.images.logoWithBrandSlogun ? appAssets.images.logoWithBrandSlogun : undefined;
    var logoOnly = appAssets && appAssets.images.logoOnly ? appAssets.images.logoOnly : undefined;
    var isRecoveryPath = /\/recovery\/?$/.test(authPath);
    var authBrandLogo = appAssets && appAssets.images.authLogoTagline ? appAssets.images.authLogoTagline : undefined;
    var authWhiteBrandLogo = appAssets && appAssets.images.authLogoTaglineWhite ? appAssets.images.authLogoTaglineWhite : undefined;
    var brandLogo = isRecoveryPath ? logoWithBrand || logoOnly : authWhiteBrandLogo || authBrandLogo || logoWithBrand || logoOnly;
    var brandLogoClassName =
        'ant-auth-area__brand-logo' + (isRecoveryPath || !authWhiteBrandLogo ? ' ant-auth-area__brand-logo--filter-white' : '');
    var appTitle = appInfo && appInfo.title ? appInfo.title : '';

    var brandBg = useMemo(() => {
        if (!appAssets || !appAssets.images) return null;
        var bgs = appAssets.images.loginBackgrounds;
        if (bgs && bgs.length > 0) return bgs[Math.floor(Math.random() * bgs.length)];
        return appAssets.images.loginBackground || null;
    }, []);

    return (
        <div className="ant-auth-area">
            {/* Left: Branding Panel */}
            <div className="ant-auth-area__brand">
                {brandBg && <img className="ant-auth-area__brand-img" src={brandBg} alt="" />}
                <div className="ant-auth-area__brand-overlay"></div>
                <div className="ant-auth-area__brand-content">
                    {!registerSubIndustry && (
                        <React.Fragment>
                            {brandLogo && <img className={brandLogoClassName} src={brandLogo} alt={appTitle} />}
                            {!brandLogo && appTitle && <div className="ant-auth-area__brand-title">{appTitle}</div>}
                            <p className="ant-auth-area__brand-tagline">Artificial Intelligence Native Transaction Engine
                                {/* {AntLocalization.translateText({
                                    vi: 'Chuyển đổi số hiệu quả nâng tầm quản trị',
                                    en: 'Welcome to the new era of business management.',
                                    fr: "Bienvenue dans la nouvelle ère de la gestion d'entreprise.",
                                    es: 'Bienvenido a la nueva era de la gestión empresarial.',
                                    id: 'Selamat datang di era baru manajemen bisnis.',
                                    ja: 'ビジネス管理の新時代へようこそ。',
                                    zh: '欢迎来到企业管理的新时代。',
                                    ko: '비즈니스 관리의 새로운 시대에 오신 것을 환영합니다.',
                                    hi: 'व्यापार प्रबंधन के नए युग में आपका स्वागत है।',
                                    ar: 'مرحباً بكم في عصر جديد من إدارة الأعمال.'
                                })} */}
                            </p>
                        </React.Fragment>
                    )}
                    {registerSubIndustry && (
                        <div className="ant-auth-area__brand-features">
                            <div className="ant-auth-area__brand-features-header">
                                {brandLogo && (
                                    <img
                                        className={brandLogoClassName}
                                        src={brandLogo}
                                        alt={appTitle}
                                        style={{ maxWidth: 120, maxHeight: 40 }}
                                    />
                                )}
                            </div>
                            <IndustryFeatures subIndustry={registerSubIndustry} />
                        </div>
                    )}
                </div>
            </div>

            {/* Right: Form Area */}
            <div className="ant-auth-area__form">
                {/* Language Switcher — top right */}
                {flags && Object.keys(flags).length > 1 && (
                    <div className="ant-auth-area__lang-switcher">
                        {Object.entries(flags).map(([lang, src]) => {
                            var isActive = currentLang === lang;
                            return (
                                <button
                                    key={lang}
                                    className={'ant-auth-area__lang-btn' + (isActive ? ' ant-auth-area__lang-btn--active' : '')}
                                    onClick={() => onChangeLanguage(lang)}
                                >
                                    <img src={src} alt={lang} className="ant-auth-area__lang-flag" />
                                </button>
                            );
                        })}
                    </div>
                )}
                <BrowserRouter>
                    <AuthRouteObserver onPathChanged={setAuthPath} />
                    <Routes>
                        <Route
                            path="/register"
                            element={
                                <AntBusinessRegister
                                    onRegisterd={props.onRegisterd}
                                    marginLeft={marginLeft}
                                    marginRight={marginRight}
                                    onSubIndustryChanged={setRegisterSubIndustry}
                                />
                            }
                        />
                        <Route
                            path="/recovery"
                            element={<AntBusinessRecovery onRecovered={props.onRecovered} marginLeft={marginLeft} marginRight={marginRight} />}
                        />
                        <Route
                            path="*"
                            element={
                                <AntUserLogin
                                    sysLanguages={sysLanguages}
                                    onLogged={props.onLogged}
                                    marginLeft={marginLeft}
                                    marginRight={marginRight}
                                />
                            }
                        />
                    </Routes>
                </BrowserRouter>
            </div>
        </div>
    );
}
